/**
* Line Connected Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Line Connected Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'line-connected-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.line-connected-left-right' ).each( function() {
        const tracker = $( this ).find( '.tracker' )[0];
        const height = $( this ).outerHeight();

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( this ).find( '.sections-area' )[0],
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            onEnter: ( {progress, direction, isActive} ) => {
              $( this ).find( '.start--unreached' ).hide();
              $( this ).find( '.start--reached' ).show();
            },
            onEnterBack: ( {progress, direction, isActive} ) => {
              $( this ).find( '.end--unreached' ).show();
              $( this ).find( '.end--reached' ).hide();
            },
            onLeave: ( {progress, direction, isActive} ) => {
              $( this ).find( '.end--unreached' ).hide();
              $( this ).find( '.end--reached' ).show();
            },
            onLeaveBack: ( {progress, direction, isActive} ) => {
              $( this ).find( '.start--unreached' ).show();
              $( this ).find( '.start--reached' ).hide();
            },
          },
        } );
        tl.to( tracker, {scaleY: '1', ease: 'linear'}, 0 );
      } );

      $( '.line-connected-left-right .section' ).each( function( sectionKey, sectionVal ) {
        const height = $( this ).outerHeight();
        const topImage = $( sectionVal ).find( '.top-image' )[0];
        const bottomImage = $( sectionVal ).find( '.bottom-image' )[0];

        const topImageMovement = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionVal,
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: true,
            immediateRender: false,
          },
        } );

        if ( $( topImage ).length ) {
          topImageMovement.to( topImage, {y: '-15%'} );
        }

        const bottomImageMovement = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionVal,
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: true,
            immediateRender: false,
          },
        } );

        if ( $( bottomImage ).length ) {
          bottomImageMovement.to( bottomImage, {y: '30%'} );
        }

        const decorativeImg = $( '.line-connected-left-right__dec-img img' );
        if ( decorativeImg.length ) {
          $( decorativeImg ).attr( 'aria-hidden', true );
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionVal,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-animated' ),
            onEnterBack: ( {progress, direction, isActive} ) => $( this ).removeClass( 'is-animated' ),
            onLeaveBack: ( {progress, direction, isActive} ) => $( this ).removeClass( 'is-animated' ),
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'line-connected-left-right', COMPONENT );
} )( app );
